export default __webpack_public_path__ + "static/media/add.c4fa83e1.svg";